import SimDto from './SimDto'

export default class SimAssignatedDto extends SimDto {
    constructor(obj) {
        super(obj)
        this.siteCode = obj.siteCode
        this.situationDate = obj.situationDate
    }
}
